/**
 * @file Public landing page — pages/Landing/ImprintPage.tsx.
 */

import React from "react";
import { Link } from "react-router-dom";
import "./LandingPage.css";

const ImprintPage: React.FC = () => {
  return (
    <div className="landing-root">
      <header className="landing-header flex justify-center items-center space-x-3 text-center py-4">
        <h1 className="landing-main-title text-4xl font-bold text-primary">
          ICoMEC
        </h1>
        <h2 className="landing-sub-title text-xl text-grayDark">
          Indian Construction Materials Embodied Carbon Data Base
        </h2>
      </header>

      <nav className="landing-nav">
        <Link to="/">Home</Link>
        <Link to="/join">Join</Link>
        <Link to="/impact">Impact</Link>
        <Link to="/research">Research and Analysis</Link>
        <Link to="/about">About</Link>
      </nav>

      <section className="landing-info" style={{ padding: "4rem 2rem", maxWidth: "900px", margin: "0 auto" }}>
        <h1 style={{ 
          fontSize: "2.5rem", 
          fontWeight: 500, 
          marginBottom: "1.5rem",
          fontFamily: "'Century Gothic', 'CenturyGothic', 'AppleGothic', sans-serif",
          color: "var(--text-color)"
        }}>
          Imprint
        </h1>
        <div style={{ 
          fontSize: "1.1rem", 
          lineHeight: "1.8", 
          color: "var(--muted)",
          fontFamily: "'Century Gothic', 'CenturyGothic', 'AppleGothic', sans-serif",
          textAlign: "left"
        }}>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </p>
          <p>
            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
          </p>
          <p>
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, 
            eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.
          </p>
          <p>
            Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos 
            qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet.
          </p>
        </div>
      </section>

      <footer className="landing-footer">
        <div className="footer-main">
          <div className="footer-left">
            <h2>ICoMEC</h2>
            <p>
              Indian Construction Materials Embodied
              <br /> Carbon Data Base
            </p>
          </div>

          <div className="footer-links">
            <div>
              <h4>About Us</h4>
              <ul>
                <li><Link to="/who-we-are">Who We Are</Link></li>
                <li><Link to="/what-we-do">What We Do</Link></li>
                <li><Link to="/leadership">Leadership</Link></li>
                <li><Link to="/partners">Partners</Link></li>
                <li><Link to="/faq">FAQ</Link></li>
                <li><Link to="/glossary">Glossary</Link></li>
              </ul>
            </div>
            <div>
              <h4>Resources</h4>
              <ul>
                {/* <li><Link to="/resource-library">Resource Library</Link></li> */}
                <li><Link to="/events">Events</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      <div className="footer-bottom">
        <p>
          <Link to="/cookies-policy">Cookies Policy</Link> · <Link to="/privacy-policy">Privacy Policy</Link> · <Link to="/legal">Legal</Link> · <Link to="/terms-of-use">Terms of Use</Link>
          {/* · <Link to="/imprint">Imprint</Link> */}
        </p>
        <p>© 2026 CARBSE. All rights reserved.</p>
      </div>
    </div>
  );
};

/** React component — Imprint Page. */
export default ImprintPage;

